/**
 * usePages
 * The custom hook which provided to external use via context
 */

import {useContext} from 'react'
import PagesContext from './pages-context'

const usePages = () => {
  const context = useContext(PagesContext)
  return context
}

export default usePages
